import React, {useEffect, useMemo, useState} from "react";
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import {connect} from "react-redux";
import ShareIcon from "@material-ui/icons/Share";
import {shareSystemsActive, shareSystemsActiveArchive, shareSystemsConnected} from "libs/shareSystems";
import PropTypes from "prop-types";
import TypographyWithIcon from "components/TypographyWithIcon";
import SendIcon from '@material-ui/icons/Send';
import {Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles} from "@material-ui/core";
import Loading from "../Loading";
import moment from "moment/moment";
import DateFormats from "../../constants/DateFormats";
import WorkableIconPrintButton from "../button/WorkableIconPrintButton";

export const sharePopupData = (name, payload) => ({name, payload})

const style = theme => ({
    button: {
        '&:not(:first-child)': {
            paddingTop: theme.spacing(2)
        }
    }
});

const ShareSelectPopup = (
    {
        data,
        loadLastShareHistory,
        loadShareHistory,
        onCancel,
        onChoose,
        demandHeader,
        classes,
        isArchive
    }) => {
    const activeShareSystems = useMemo(() => shareSystemsActive(demandHeader), [demandHeader])
    const activeArchiveShareSystems = useMemo(() => shareSystemsActiveArchive(demandHeader), [demandHeader])
    const activeSystems = isArchive ? activeArchiveShareSystems : activeShareSystems;
    const connectedShareSystems = useMemo(() => shareSystemsConnected(demandHeader), [demandHeader]);
    const showHistory = !!loadLastShareHistory;
    const [lastShareHistory, setLastShareHistory] = useState(null);
    const [shareHistory, setShareHistory] = useState(null);


    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onCancel));
        return buttons;
    }

    useEffect(() => {
        if (!!data && !!loadLastShareHistory) {
            loadLastShareHistory().then(resp => {
                setLastShareHistory(resp.result);
            });
        } else {
            setLastShareHistory(null);
        }
    }, [data, loadLastShareHistory]);

    const getHistoryDate = (system) => {
        const lastSystemHistory = lastShareHistory.find(x => x.externalSystem === system);
        if (!!lastSystemHistory) {
            return moment(lastSystemHistory.date).format(DateFormats.DATETIME_FORMAT);
        } else {
            return Tr('share_last_date_not_found');
        }
    }

    const noHistory = (system) => {
        return lastShareHistory.find(x => x.externalSystem === system) === undefined;
    }

    const doLoadShareHistory = (system) => {
        loadShareHistory(system).then(resp => setShareHistory(resp.result));
    }

    return (<Dialog
        open
        title={Tr("int_choose_popup_title")}
        maxWidth={showHistory ? 'md' : 'sm'}
        onClose={onCancel}
        dialogActions={<MultiButton buttons={getButtons()}/>}
    >
        {showHistory && !lastShareHistory && <Loading/>}
        {(!showHistory || !!lastShareHistory) && <>
            <TypographyWithIcon Icon={SendIcon}>{data.name}</TypographyWithIcon>
            <br/>
            <GridBlock justify="center" alignItems="center" column itemClassName={classes.button}>
                {
                    activeSystems.map(x =>
                        (<GridBlock
                            key={x}
                            alignItems='center'
                            justify={showHistory ? 'space-between' : 'center'}
                        >
                            <Button
                                    disabled={!connectedShareSystems.includes(x)}
                                    tooltip={!connectedShareSystems.includes(x) ? Tr("int_demand_not_connected_x", {x}, true) : undefined}
                                    onClick={() => onChoose(data.payload, x)}
                                    Icon={ShareIcon}
                            >{Tr("int_upload_x", {x}, true)}</Button>
                            {showHistory && <GridBlock alignItems='center' justify='flex-end'>
                                <Typography>{`${Tr('share_last_date')}: ${getHistoryDate(x)}`}</Typography>
                                <WorkableIconPrintButton
                                    onClick={() => doLoadShareHistory(x)}
                                    tooltip={Tr('share_history')}
                                    working={false}
                                    disabled={noHistory(x)}
                                />
                            </GridBlock>
                            }
                        </GridBlock>))
                }
            </GridBlock>
        </>}
        {!!shareHistory && <Dialog
            open
            title={Tr('share_history_' + shareHistory[0].externalSystem)}
            onClose={() => setShareHistory(null)}
            >
            <TypographyWithIcon Icon={SendIcon}>{data.name}</TypographyWithIcon>
            <br/>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{Tr("share_user")}</TableCell>
                        <TableCell>{Tr("share_date")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {shareHistory.map((x, index) => (
                       <TableRow key={`sh_${index}`}>
                           <TableCell>{x.user}</TableCell>
                           <TableCell>{moment(x.date).format(DateFormats.DATETIME_FORMAT)}</TableCell>
                       </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Dialog>}
    </Dialog>)
}

ShareSelectPopup.propTypes = {
    data: PropTypes.shape({
        name: PropTypes.string.isRequired,
        payload: PropTypes.object,
    }).isRequired,
    onCancel: PropTypes.func.isRequired,
    onChoose: PropTypes.func.isRequired,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader
}), {})(withStyles(style)(ShareSelectPopup))